export const APPLY_GREETENGS =
  'We have received your request. We’ll get back to you as soon as possible. If we don’t reach you within 3 business days, some failure has occurred. Please contact us directly on ';
export const ACTION_GREETINGS =
  'We have received your request. A little more, and we will unleash geospatial power on you. If we don’t reach you within 3 business days, some failure has occurred. Please contact us directly on ';
